const $ = window.$;
const moment = window.moment;
const Vue = window.Vue;
const Cookies = window.Cookies;

import { productDetailViewTracking, addToCartTracking } from '../afew.tagmanager';
import { viewedProduct, stockUpdateSubscribed, addedToCart } from '../afew.klaviyo';

const productApp = new Vue({
  el: '#product-section',
  data: {
    // array of size run columns of the current product
    size_columns: [],
    // user selected size type - EU
    size_type: '',
    // alternate size type for tooltip - US
    size_type_alt: '',
    // variants of the current product
    variants: window.current_product.variants,
    // currently selected product variant
    selected_variant: {},
    // product object including size_chart and eet_product object
    current_product: window.current_product,
    // has status coming soon or is before release or is up to 2h after release and status is available but still has no stock but
    is_coming_soon_product: (window.current_product.status_tag === 'comingsoon'),
    // display countdown until release
    release_countdown: false,
    // is updated when the raffle product from raffles.afew-store.com can be fetched
    is_afew_raffle: false,
    // is true for 2hrs after raffle
    is_raffle_running: false,
    // raffle form fields
    raffle_instagram: '',
    // is set in custom product template for instagram ticket
    force_instagram: window.force_instagram ? true : false,
    raffle_terms: false,
    // show all tiles, if button is clicked
    show_all_tiles: false,
    material_info: false,
    // show all product groupings
    show_grouping_rows: false
  },
  created() {
    productDetailViewTracking(this.current_product.eet_product);

    // Klaviyo Viewed Product and "Recently Viewed Items" tracking
    viewedProduct(this.current_product.klaviyo_product);

    if (window.selected_variant_sku) {
      this.selectVariant(window.selected_variant_sku);
    }

    // init size types
    if (window.size_chart) {
      // get the keys from the size chart rows
      const sizeChartKeys = Object.keys(window.size_chart);
      if (sizeChartKeys.length) {
        // safe the keys of the first row as size column titles
        this.size_columns = Object.keys(window.size_chart[sizeChartKeys[0]]);
      }
    }

    if (!this.size_columns.length) {
      return;
    }

    // first size column is selected as default
    this.size_type = this.size_columns[0];

    // override value from local storage
    const preferredSizeType = window.getPreferredSizeType(this.size_columns);
    if (preferredSizeType) {
      this.size_type = preferredSizeType;
    }
  },
  mounted() {
    this.initTooltips();
    this.initRaffleCheckout();
    this.initReleaseCountdown();
    this.initStockUpdate();
    this.scrollToSelected();
  },
  watch: {
    size_type(val) {
      // save all size columns with selected value to local storage
      window.setPreferredSizeType(val, this.size_columns);

      // set alternate size to default
      this.size_type_alt = this.size_columns[0];

      // update alternate size if available
      if ((this.size_columns.length > 1) && (val === this.size_columns[0])) {
        this.size_type_alt = this.size_columns[1];
      }
    },
  },
  methods: {
    initReleaseCountdown() {
      const releaseDate = this.current_product.release_date;
      const releaseDateObj = moment.tz(releaseDate, 'Europe/Berlin');
      if (!releaseDateObj.isValid()) {
        return;
      }

      const nowDateObj2 = moment();
      const releaseDateEnd = moment(releaseDateObj).add(2, 'hours');
      const isReleaseRunning = releaseDateObj.isBefore(nowDateObj2) && releaseDateEnd.isAfter(nowDateObj2);
      this.is_raffle_running = (this.current_product.release_type === 'raffle') && isReleaseRunning;
      //product is also comming soon id release date is in the future or if it has no stock online 2 hours after release
      this.is_coming_soon_product = this.is_coming_soon_product || releaseDateObj.isAfter(nowDateObj2) || (!this.current_product.available && (this.current_product.status_tag === 'available') && isReleaseRunning);

      const updateCountdown = () => {
        const nowDateObj = moment();
        if (releaseDateObj.isBefore(nowDateObj)) {
          return;
        }
        const duration = moment.duration(releaseDateObj.diff(nowDateObj));
        if (duration.months() >= 1) {
          return;
        }
        this.release_countdown = {
          days: String(duration.days()).padStart(2, '0'),
          hours: String(duration.hours()).padStart(2, '0'),
          minutes: String(duration.minutes()).padStart(2, '0'),
          seconds: String(duration.seconds()).padStart(2, '0'),
        };

        if (window.requestAnimationFrame) {
          setTimeout(() => window.requestAnimationFrame(updateCountdown), 200);
        }
      };

      if (window.requestAnimationFrame) window.requestAnimationFrame(updateCountdown);
    },
    initStockUpdate() {
      window.addEventListener("klaviyoForms", function (e) {
        if (e.detail.formId == window.stock_update_form_id && (e.detail.type == 'submit' || e.detail.type == 'redirectedToUrl')) {
          stockUpdateSubscribed(this.current_product.klaviyo_product);
        }
      });
    },
    initTooltips() {
      $('.size-picker > ul > li').tooltip({
        placement: 'bottom',
        html: false,
        offset: 50,
      });
      $('[data-toggle="material_info"]').tooltip({
        template: '<div class="tooltip material-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-4 py-3"></div></div>',
        placement: 'auto'
      });
    },
    selectVariant(sku) {
      this.selected_variant = this.variants[sku];
    },
    onAddToCartFormSubmit() {
      //console.log('onAddToCartFormSubmit')

      if (window.mediastation && window.addToMediastation) {
        window.addToMediastation({
          sku: this.selected_variant.sku,
          thumb: this.current_product.thumb,
        });
        return;
      }

      const self = this;
      const eetProduct = $.extend({}, this.current_product.eet_product);
      eetProduct.quantity = 1;
      if (this.selected_variant.title && this.selected_variant.sku) {
        eetProduct.variant = this.selected_variant.title;
        eetProduct.sku = this.selected_variant.sku;
      }

      if (this.is_afew_raffle) {
        let locale = 'en';
        if (window.locale) {
          locale = window.locale.toLowerCase();
        }

        const utmSource = Cookies.get('afew.source.click') || '';
        addToCartTracking([eetProduct], () => {
          window.location.href = `https://raffles.afew-store.com/cart/${this.selected_variant.raffle_id}:1?locale=${locale}&attributes%5Blocale%5D=${locale}&attributes%5Binstagram%5D=${this.raffle_instagram}&utm_source=${utmSource}`;
        });
        return;
      }

      // klaviyo tracking
      addedToCart($.extend({ SKU: this.selected_variant.sku }, this.current_product.klaviyo_product));

      // tagmanager tracking
      addToCartTracking([eetProduct], () => {
        //console.log('addToCartTrackingCallback');
        self.$refs.form.submit();
      });
    },
    initRaffleCheckout() {
      const raffleHandle = this.current_product.raffle_handle;
      if (!raffleHandle) {
        return;
      }

      $.getJSON(`//raffles.afew-store.com/products/${raffleHandle}.json`).done((response) => {
        if (!response.product || !response.product.variants) {
          return;
        }

        this.is_afew_raffle = true;
        this.current_product.available = true;
        response.product.variants.forEach((item) => {
          const variant = this.variants[item.sku];
          if (!variant) {
            return;
          }
          variant.raffle_id = item.id;
          variant.available = true;
        });
        this.$forceUpdate();
      });
    },
    scrollToSelected() {
      if (window.modelGroupingScrollLeft) {
        this.$refs.modelgrouping.scrollLeft = window.modelGroupingScrollLeft;
      }
    }
  },
});
window.productApp = productApp;
